
<template>
<section>
  <div>
    <div class="columns">
      <div class="col">
        <chc-input v-model="data.description" label="Note" :required="true"></chc-input>
        <!-- <chc-input v-model="data.charity_id" label="Charity" format="combo" :autoCompleteValues="$store.state.summary.charities" :required="true"></chc-input> -->
        <chc-input v-model="data.status" label="Status" format="combo" :autoCompleteValues="$store.state.constants.referral_sources.referral_source_status" :required="true"></chc-input>
        <div v-for="(error, index) in errors" :key="index" class="error-block">
          <span class="error-message"> {{ error }} </span>
        </div>
        <div class="field buttons">
          <input type="submit" class="btn" value="Save" @click="submit">
          <!-- <a class="secondary-action" @click="deleteSource">Delete Source</a> -->
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import store from '@/store'

export default {
  name: 'SourceEdit',
  props: ['data', 'sourceId'],
  data () {
    return {
      errors: {}
    }
  },
  methods: {
    submit () {
      store.functions.sources.editSource(this.sourceId, this.data,
        (errors) => {
          this.errors = errors
        }).then(() => {
        this.$emit('refresh')
        this.$emit('close')
      })
    },
    deleteSource () {
      // store.functions.sources.deleteSource(this.sourceId, (errors) => {
      //   this.errors = errors
      // }).then(() => {
      //   this.$emit('refresh')
      //   this.$emit('close')
      // })
    },
    setData (data, sourceId) {
      this.data = data
    }
  },
  computed: {
  }
}
</script>

<style scoped>

#buyer-status {
    width: 80%;
}

.field .left {
    padding-top: 4em;
}

section {
    width: 400px;
}

.error-block:last-child {
    margin-bottom: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Source/SourceEdit.vue